module.exports = __webpack_public_path__ + "static/media/Dec_2025_3.8660e36c.webp";